import { Colors as NedColors } from '../components/utilities/Material';
import { Colors as WatchmanColors } from '../components/utilities/MaterialWatchman';
import { getStyle } from './stylesSelector';

export function getCustomColors() {
    return getStyle({ ned: NedColors, watchman: WatchmanColors });
}
